export default "__VITE_ASSET__BxlU2uxD__"